module.exports = __webpack_public_path__ + "career-icon-team.IagFOAVK.svg";